import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscriber, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ChangeOperationType } from '../enums/ChangeOperationType';
import { ChangeType } from '../enums/ChangeType';
import { EditDataList, IEditDataList } from '../models/DTOs/IEditDataList';
import { IEnvelopeInDTO } from '../models/DTOs/IEnvelopeInDTO';
import { IEnvelopeOutDTO } from '../models/DTOs/IEnvelopeOutDTO';
import { ISalesAreaDTO } from '../models/DTOs/ISalesAreaDTO';
import { ISalesArea } from '../models/ISalesArea';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class SalesAreasService {
  private SalesAreaEndPoint = environment.APIEndpoint +  'frontend/corporation/{corporationId}/site/{siteId}/SalesArea';

  constructor(private loginService: LoginService, private http: HttpClient) { }

  GetSalesAreas(CorporationID: string, SiteID: string): Observable<ISalesArea[]> {
    const Token: string = this.loginService.AccessToken.authToken;
    if (Token !== '') {
      const endPoint: string = this.SalesAreaEndPoint.replace('{corporationId}', CorporationID).replace('{siteId}', SiteID);

      return this.http.get(endPoint, { headers: new HttpHeaders().set('Authorization', 'Bearer ' + Token), observe: 'response' }).pipe(
        map((data: HttpResponse<ISalesAreaDTO[]>) => {

          if (data.ok) {
            return this.formatData(data.body);
          }

        }), 
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      );
    }
  }

  private formatData(dataList: ISalesAreaDTO[]): ISalesArea[] {
    let list: ISalesArea[] = [];

    // convert SalesAreas items => ISalesArea
    dataList.forEach(pl => {
      list.push({
        id: pl.id,
        salesAreaGuid: pl.salesAreaGuid,
        description: pl.description,
        isSelected: false,
        changeState: ChangeType.None
      });
    });

    // sort data
    this.sortData(list);

    return list;
  }

  private sortData(list: ISalesArea[]): ISalesArea[] {
    return list.sort((Item1: ISalesArea, Item2: ISalesArea) => {
      if (Item1.description.toLowerCase() > Item2.description.toLowerCase()) {
        return 1;
      }

      if (Item1.description.toLowerCase() < Item2.description.toLowerCase()) {
        return -1;
      }
    });
  }

  SaveSalesAreas(CorporationID: string, SiteID: string, oldData: ISalesArea[], newData: ISalesArea[]): Observable<ISalesArea[]> {
    const Token: string = this.loginService.AccessToken.authToken;
    if (Token !== '') {
      const endPoint: string = this.SalesAreaEndPoint.replace('{corporationId}', CorporationID).replace('{siteId}', SiteID);

      const data: IEditDataList<ISalesAreaDTO> = this.SplitItems(newData);

      return this.http.post(endPoint, data, { headers: new HttpHeaders().set('Authorization', 'Bearer ' + Token), observe: 'response' }).pipe(
        map((data: HttpResponse<ISalesAreaDTO[]>) => {
          
          if (data.ok) {
            return this.formatData(data.body);
          }
          
        }), 
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      );
    }
  }

  private DeflateItems(list: ISalesArea[]): ISalesAreaDTO[] {
    const newData: ISalesAreaDTO[] = [];

    if (list != null) {
      list.forEach(item => {
        newData.push({
          id: item.id,
          salesAreaGuid: item.salesAreaGuid,
          description: item.description
        });
      });
    }

    return newData;
  }

  private SplitItems(data: ISalesArea[]): IEditDataList<ISalesAreaDTO> {
    let newData: IEditDataList<ISalesAreaDTO> = new EditDataList<ISalesAreaDTO>();

    newData.newItems = this.DeflateItems(data.filter(i => i.changeState === ChangeType.New));
    newData.editItems = this.DeflateItems(data.filter(i => i.changeState === ChangeType.Edited));
    newData.deleteItems = this.DeflateItems(data.filter(i => i.changeState === ChangeType.Deleted));

    return newData;
  }
}
